<!-- ══════════════════════════════════════════════════════════════
Encabezado
═══════════════════════════════════════════════════════════════ -->
<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<app-kpi-strip [kpis]="kpis" [active]="activeKpi" (activeChange)="setKpi($event)"></app-kpi-strip>

<!-- ══════════════════════════════════════════════════════════════
Captura: almacén + los dos procesos del forms
═══════════════════════════════════════════════════════════════ -->
<div class="filter-bar">
  <div class="filter-card">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="warehouse-field">
    <mat-label>Ubicación (hospital)</mat-label>
    <mat-select [(value)]="selectedPlace" (selectionChange)="onPlaceChange()">
      @for (p of hospitals; track p.id) {
        <mat-option [value]="p.id">{{ p.alias || p.name }}</mat-option>
      }
    </mat-select>
    <mat-icon matPrefix>local_hospital</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="warehouse-field">
    <mat-label>Locker que recibe</mat-label>
    <mat-select [(value)]="selectedWarehouse" [disabled]="!selectedPlace">
      @for (w of warehousesOfPlace; track w.id) {
        <mat-option [value]="w.id">{{ w.name }}{{ w.location ? ' · ' + w.location : '' }}</mat-option>
      }
      @if (selectedPlace && warehousesOfPlace.length === 0) {
        <mat-option disabled>Este hospital no tiene lockers</mat-option>
      }
    </mat-select>
    <mat-icon matPrefix>warehouse</mat-icon>
  </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Periodo</mat-label>
      <mat-date-range-input [rangePicker]="periodPicker">
        <input matStartDate [(ngModel)]="periodStart" placeholder="Inicio" (dateChange)="loadEntries()">
        <input matEndDate [(ngModel)]="periodEnd" placeholder="Fin" (dateChange)="loadEntries()">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
      <mat-date-range-picker #periodPicker></mat-date-range-picker>
    </mat-form-field>
    <app-search-pill placeholder="Buscar en la bitácora: delivery, locker, quién entregó…" (valueChange)="applySearch($event)"></app-search-pill>
    <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <app-filter-chips [chips]="periodChips" [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="entradas"></app-filter-chips>
</div>

<div class="list-actions list-actions--page">
  <button mat-stroked-button (click)="pageLoad.refresh(loadEntries())"><mat-icon>refresh</mat-icon> Actualizar</button>
  <button mat-flat-button color="primary" (click)="openReception(false)">
    <mat-icon>local_shipping</mat-icon> Entrada de material · DLV
  </button>
</div>

<app-selection-bar [count]="sel.count" (export)="exportSelection()" (clear)="sel.clear()"></app-selection-bar>

<!-- ══════════════════════════════════════════════════════════════
Bitácora de entradas
═══════════════════════════════════════════════════════════════ -->
<div class="table-section">
  <div class="table-title">
    <mat-icon>receipt_long</mat-icon>
    <span>Bitácora de entradas</span>

  </div>

  @if (loading()) {
    <div class="loading-row">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Cargando entradas...</span>
    </div>
  }


  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (s of dataSource.filteredData; track s.id) {
        <div class="cat-card" [class.cat-card--selected]="sel.isSelected(s)">
          <div class="cat-card__head">
            <mat-checkbox color="primary" [checked]="sel.isSelected(s)" (change)="sel.toggle(s)" matTooltip="Seleccionar"></mat-checkbox>
            <span class="cat-card__title">{{ s.fileNumber ?? 'Sin folio' }}</span>
            <span class="list-status">{{ s._tagged }} / {{ s._pieces }} RFID</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Fecha:</span><span class="cat-card__value">{{ formatDate(s.createdOn) }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Hospital:</span><span class="cat-card__value">{{ s._place || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Destino:</span><span class="cat-card__value">{{ s._warehouse || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">No. Delivery:</span><span class="cat-card__value">{{ s._source || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Documento firmado:</span><span class="cat-card__value">{{ s._signed ? 'Sí' : 'No' }}</span></div>
            @if (s.comments) {<div class="cat-card__field"><span class="cat-card__label">Comentarios:</span><span class="cat-card__value">{{ s.comments }}</span></div>}
          </div>
          <div class="cat-card__actions">
            <button mat-icon-button [color]="s._signed ? 'primary' : undefined"
                    [matTooltip]="s._signed ? 'Documento firmado (ver / reemplazar)' : 'Cargar documento firmado (foto o PDF)'"
                    (click)="openSigned(s)"><mat-icon>{{ s._signed ? 'task' : 'upload_file' }}</mat-icon></button>
            <button mat-icon-button color="accent" matTooltip="Asociar etiquetas RFID (agrega las piezas al locker)" (click)="openRfid(s)"><mat-icon>contactless</mat-icon></button>
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) {
        <p class="inv-cards__empty">Sin entradas registradas</p>
      }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-cell">
          <mat-checkbox color="primary" (change)="$event ? sel.toggleAll() : null" [checked]="sel.allSelected()" [indeterminate]="sel.someSelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="select-cell">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? sel.toggle(row) : null" [checked]="sel.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="fileNumber">
        <th mat-header-cell *matHeaderCellDef>Folio</th>
        <td mat-cell *matCellDef="let s"><code class="folio-badge">{{ s.fileNumber ?? '—' }}</code></td>
      </ng-container>

      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let s">{{ formatDate(s.createdOn) }}</td>
      </ng-container>

      <ng-container matColumnDef="place">
        <th mat-header-cell *matHeaderCellDef>Hospital</th>
        <td mat-cell *matCellDef="let s">{{ s._place || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="warehouse">
        <th mat-header-cell *matHeaderCellDef>Destino</th>
        <td mat-cell *matCellDef="let s">{{ s._warehouse }}</td>
      </ng-container>

      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef>No. Delivery</th>
        <td mat-cell *matCellDef="let s">{{ s._source || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="pieces">
        <th mat-header-cell *matHeaderCellDef>Piezas (con RFID)</th>
        <td mat-cell *matCellDef="let s">{{ s._tagged }} / {{ s._pieces }}</td>
      </ng-container>

      <ng-container matColumnDef="backorder">
        <th mat-header-cell *matHeaderCellDef>Backorder / extras</th>
        <td mat-cell *matCellDef="let s">
          @if (s._backorder) { <span class="chip chip--warn" [matTooltip]="s._backorderText">{{ s._backorder }} pendiente(s)</span> }
          @if (s._extra) { <span class="chip chip--open" [matTooltip]="s._extraText">{{ s._extra }} extra(s)</span> }
          @if (!s._backorder && !s._extra) { <span class="muted">—</span> }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let s" class="actions-cell">
          <button mat-icon-button [color]="s._signed ? 'primary' : undefined"
                  [matTooltip]="s._signed ? 'Documento firmado (ver / reemplazar)' : 'Cargar documento firmado (foto o PDF)'"
                  (click)="openSigned(s)">
            <mat-icon>{{ s._signed ? 'task' : 'upload_file' }}</mat-icon>
          </button>
          <button mat-icon-button color="accent" matTooltip="Asociar etiquetas RFID (agrega las piezas al locker)" (click)="openRfid(s)">
            <mat-icon>contactless</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="comments">
        <th mat-header-cell *matHeaderCellDef>Comentarios</th>
        <td mat-cell *matCellDef="let s">{{ s.comments ?? '' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>

      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length">
          <div class="no-data">
            <mat-icon>inbox</mat-icon>
            <span>Sin entradas registradas</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
